import React, { useEffect, useRef, useState } from "react";
import axios from "../../../../../config/axios";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Form, Formik } from "formik";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { dateFormatter } from "../../../../../global";

const GuestPassDialog = ({ stay, handleClose }) => {
  function submit(data, { setSubmitting, setStatus }) {
    setSubmitting(true);
    setLoading(true);
    axios
      .post(`/api/v1/stays/${stay.id}/lts_guest_passes/create_and_update.json`)
      .then(function (response) {
        setGuestPassData(response.data);
        setSubmitting(false);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setSubmitting(false);
        setLoading(false);
      });
  }

  const formRef = useRef();
  const { t } = useTranslation("dashboard");
  const [guestPassData, setGuestPassData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getGuestPass = () => {
    setLoading(true);
    axios
      .get(`/api/v1/stays/${stay.id}/lts_guest_passes.json`)
      .then((response) => {
        setGuestPassData(response.data);
        setLoading(false);
      });
  };

  useEffect(() => {
    getGuestPass();
  }, []);

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            {t("booking_details.guest_pass_dialog.title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            innerRef={formRef}
            initialValues={{
              ...stay,
              checkin_at: moment().format(moment.HTML5_FMT.DATETIME_LOCAL),
            }}
            onSubmit={submit}
          >
            <Form>
              {loading ? (
                <Spinner
                  className={"d-block mx-auto"}
                  animation="border"
                  variant="primary"
                />
              ) : (
                <>
                  <div>
                    {guestPassData.guest_passes.length > 0 && (
                      <p>{t("booking_details.guest_pass_dialog.paragraph1")}</p>
                    )}
                  </div>

                  {guestPassData.api_errors?.length > 0 && (
                    <div className={"mb-3"}>
                      <h5 className="text-black">Fehler</h5>

                      {guestPassData.api_errors.map((error) => (
                        <div>
                          <span className="text-danger">{error}</span>
                        </div>
                      ))}
                    </div>
                  )}

                  {guestPassData.guest_passes.map((guestPass, index) => (
                    <div key={guestPass.id} className={"mb-3"}>
                      <div className={"mb-1"}>
                        <span className="pr-2 text-black">
                          {t("booking_details.guest_pass_dialog.name.label")}:
                        </span>
                        <span>
                          {guestPass.first_name} {guestPass.last_name}
                        </span>
                      </div>
                      <div className={"mb-1"}>
                        <span className="pr-2 text-black">
                          {t(
                            "booking_details.guest_pass_dialog.birth_date.label"
                          )}
                          :
                        </span>
                        <span>
                          {guestPass.birth_date &&
                            dateFormatter(guestPass.birth_date)}
                        </span>
                      </div>
                      {guestPass.card.status === "active" && (
                        <div className={"mb-1"}>
                          <span className="pr-2 text-black">
                            {t(
                              "booking_details.guest_pass_dialog.card_number.label"
                            )}
                            :
                          </span>
                          <span>{guestPass.card.number}</span>
                        </div>
                      )}
                      <div className={"mb-1"}>
                        <span className="pr-2 text-black">
                          {t("booking_details.guest_pass_dialog.status.label")}:
                        </span>
                        <span
                          className={classNames({
                            "text-success": guestPass.card.status === "active",
                            "text-danger": guestPass.card.status !== "active",
                          })}
                        >
                          {guestPass.card.formatted_status}
                        </span>
                      </div>
                      {guestPass.card.status === "active" && (
                        <div className={"mb-1"}>
                          <span className="pr-2 text-black">
                            {t("booking_details.guest_pass_dialog.pdf.label")}:
                          </span>
                          <Link
                            to={{ pathname: guestPass.card.pdf_url }}
                            target={"_blank"}
                          >
                            {t(
                              "booking_details.guest_pass_dialog.download_pdf"
                            )}
                          </Link>
                        </div>
                      )}
                      <div className={"mb-1"}>
                        <span className="pr-2 text-black">Gültigkeit:</span>
                        <span>
                          {dateFormatter(guestPass.checkin_at)} -{" "}
                          {dateFormatter(guestPass.checkout_at)}
                        </span>
                      </div>
                      {guestPass.errors.length > 0 && (
                        <div className={"mb-1"}>
                          <span className="pr-2 text-black">Fehler:</span>
                          {guestPass.errors.map((error) => (
                            <span className={"text-error"}>{error}</span>
                          ))}
                        </div>
                      )}
                      {guestPassData.guest_passes.length !== index + 1 && (
                        <hr />
                      )}
                    </div>
                  ))}

                  {guestPassData.guest_passes.length === 0 && (
                    <div className={"mb-3"}>
                      {t("booking_details.guest_pass_dialog.no_cards")}
                    </div>
                  )}

                  {guestPassData.webapp_url && (
                    <>
                      <small>
                        {t("booking_details.guest_pass_dialog.attention")}
                      </small>
                      <small>
                        &nbsp;
                        <Link
                          to={{ pathname: guestPassData.webapp_url }}
                          target={"_blank"}
                        >
                          LTS Portal öffnen
                        </Link>
                      </small>
                    </>
                  )}
                </>
              )}
            </Form>
          </Formik>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Schließen
          </Button>
          <Button onClick={() => formRef?.current?.handleSubmit()}>
            {t("booking_details.guest_pass_dialog.update")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default GuestPassDialog;
